import { Environment } from './type';

export const environment: Environment = {
  production: false,
  appInsightsKey: undefined,
  apiBaseUrlPrefix: 'https://ama-calculator.azurewebsites.net',
  accessKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9',
};
